import { render, staticRenderFns } from "./toggleButton.pug?vue&type=template&id=0c4ba726&lang=pug&"
import script from "./toggleButton.js?vue&type=script&lang=js&"
export * from "./toggleButton.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4ba726')) {
      api.createRecord('0c4ba726', component.options)
    } else {
      api.reload('0c4ba726', component.options)
    }
    module.hot.accept("./toggleButton.pug?vue&type=template&id=0c4ba726&lang=pug&", function () {
      api.rerender('0c4ba726', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/toggleButton/index.vue"
export default component.exports